import routes from "routes/routes";

export const getPathToCertificationToBeSignedDetails = (id: string): string =>
  routes.certificationToBeSignedDetails.path.replace(":certificationId", id);

export const getPathToCertificationToBeSignedDetailsOverview = (
  id: string
): string =>
  routes.certificationToBeSignedDetailsOverview.path.replace(
    ":certificationId",
    id
  );

export const getPathToCertificationToBeSignedDetailsSessions = (
  id: string
): string =>
  routes.certificationToBeSignedDetailsSessions.path.replace(
    ":certificationId",
    id
  );
